import IntroductionWithImage from "../../../components/IntroductionWithImage";
import MainImageCarousel from "../../../components/MainImageCarousel";
import StickyNavAndFooter from "../../layout/StickyNavAndFooter";
import { yogaMainBlog, nadaYogaPageIntroduction } from "../../../data/data";
import nadaYogaImg from '../../../resources/images/nadayoga.png'
import { CarouselCardDetails_t } from "../../../components/Carousels/CarouselCard";
import { Flex, Text } from "@chakra-ui/react";
import { headingTertiaryFont, primaryColor } from "../../../config";
import { routes } from "../../../data/path";
import SoundExperience from "./SoundExperience";
import NadaBenefits from "./NadaBenefits";
import NonStickyNavAndFooter from "../../layout/NonStickyNavAndFooter";


export default function NadaYoga() {
    const yogaMainBlogForYogaPage: CarouselCardDetails_t = yogaMainBlog
    delete yogaMainBlogForYogaPage.previous;
    delete yogaMainBlogForYogaPage.next;

    return (
        <NonStickyNavAndFooter>
            {/* <MainImageCarousel /> */}
            {/* <IntroductionWithImage img={nadaYogaImg}>
                {nadaYogaPageIntroduction}
                <br />
            </IntroductionWithImage> */}
            <br />
            <SoundExperience />
            <Flex justifyContent="center">
                <Text as="a" href={routes.contact} textAlign={"center"} fontSize={headingTertiaryFont}
                    color={primaryColor}>
                    Contact Us for more information
                </Text>
            </Flex>
        </NonStickyNavAndFooter>
    )
}